export enum UnloadingDetailsEnum {
  DROP = "DROP",
  LIVE = "LIVE",
}

export type UnloadingDetails = `${UnloadingDetailsEnum}`;
